import React from 'react';
import { GlobalState } from '../types/common';

export const isCorrectPlaceToShowSMSPopup = (globalContext: GlobalState): boolean => {
  const liquid = globalContext.liquid;
  const customer = globalContext.customer;
  const currentPage = window.gb.liquid.template;
  const donotShowOnPagesForSubcriber = [
    'page.size-quiz',
    'page.pricing-and-plan-selection',
    'page.subscribe',
    'page.subscription-successful',
    'page.privacy-policy',
    'page.terms-of-service'
  ];
  const donotShowOnPagesForGuest = [
    'page.size-quiz',
    'index',
    'page.privacy-policy',
    'page.terms-of-service'
  ];
  const showSMSService = liquid.settings.showSMSService;
  const showSMSForSubscriber = customer && customer.isSubscriber() && donotShowOnPagesForSubcriber.indexOf(currentPage) === -1;
  const showSMSForGuest = customer && customer.isGuest() && donotShowOnPagesForGuest.indexOf(currentPage) === -1;

  return (showSMSService && (showSMSForSubscriber || showSMSForGuest));
};

export const getValidAreaCode = (): number[] => {
  const usAreaCode = [201, 202, 203, 205, 206, 207, 208, 209, 210, 212,
    213, 214, 215, 216, 217, 218, 219, 224, 225, 228, 229, 231, 234, 239,
    240, 248, 251, 252, 253, 254, 256, 260, 262, 267, 269, 270, 276, 281,
    301, 302, 303, 304, 305, 307, 308, 309, 310, 312, 313, 314, 315, 316,
    317, 318, 319, 320, 321, 323, 325, 330, 334, 336, 337, 339, 347, 351,
    352, 360, 361, 386, 401, 402, 404, 405, 406, 407, 408, 409, 410, 412,
    413, 414, 415, 417, 419, 423, 425, 430, 432, 434, 435, 440, 443, 469,
    478, 479, 480, 484, 501, 502, 503, 504, 505, 507, 508, 509, 510, 512,
    513, 515, 516, 517, 518, 520, 530, 540, 541, 551, 559, 561, 562, 563,
    567, 570, 571, 573, 574, 575, 580, 585, 586, 601, 602, 603, 605, 606,
    607, 608, 609, 610, 612, 614, 615, 616, 617, 618, 619, 620, 623, 626,
    630, 631, 636, 641, 646, 650, 651, 660, 661, 662, 678, 682, 701, 702,
    703, 704, 706, 707, 708, 712, 713, 714, 715, 716, 717, 718, 719, 720,
    724, 727, 731, 732, 734, 740, 754, 757, 760, 763, 765, 770, 772, 773,
    774, 775, 781, 785, 786, 801, 802, 803, 804, 805, 806, 808, 810, 812,
    813, 814, 815, 816, 817, 818, 828, 830, 831, 832, 843, 845, 847, 848,
    850, 856, 857, 858, 859, 860, 862, 863, 864, 865, 866, 870, 901, 903,
    904, 906, 907, 908, 909, 910, 912, 913, 914, 915, 916, 917, 918, 919,
    920, 925, 928, 931, 936, 937, 940, 941, 947, 949, 951, 952, 954, 956,
    970, 971, 972, 973, 978, 979, 980, 985, 989, 669];

  return usAreaCode;
};

export const getNumericPhoneNumber = (formattedPhoneNum: string): string => {
  let phoneVal = '';

  for (let idx = 0; idx < formattedPhoneNum.length; idx++) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(parseInt(formattedPhoneNum.charAt(idx), 10)) && formattedPhoneNum.charAt(idx) !== ' ') {
      phoneVal += formattedPhoneNum.charAt(idx);
    }
  }

  return phoneVal;
};

export const addSpace = (e: React.KeyboardEvent<HTMLInputElement>): string => {
  let elemVal = e.currentTarget.value;
  const length = elemVal.length;

  if (length === 1) {
    elemVal = '(' + elemVal;
  } else if (length === 4) {
    elemVal += ') ';
  } else if (length === 9) {
    elemVal += '-';
  }

  return elemVal;
};

export const formatPhoneNum = (e: React.ChangeEvent<HTMLInputElement>): string => {
  const phoneNo = e.currentTarget.value;
  let phoneVal = getNumericPhoneNumber(phoneNo);

  if (phoneVal.length > 0 && phoneVal.length < 3) {
    phoneVal = '(' + phoneVal;
  } else if (phoneVal.length >= 3 && phoneVal.length < 7) {
    phoneVal = '(' + phoneVal.substring(0, 3) + ') ' + phoneVal.substring(3, 6);
  } else if (phoneVal.length >= 7) {
    phoneVal = '(' + phoneVal.substring(0, 3) + ') ' + phoneVal.substring(3, 6) + '-' + phoneVal.substring(6, 10);
  }

  return phoneVal;
};
